<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import type { Snippet } from "svelte";
	import PlusMinusButton from "./PlusMinusButton.svelte";

	const {
		question,
		children,
	}: {
		children: Snippet;
		question: string;
	} = $props();

	let open = $state(false);
</script>

<article
	class="border-nov-light-200 flex flex-col border-t last:border-b text-nov-dark-800 bg-nov-light-100 rounded-2xl lg:rounded-3xl border"
>
	<label class="flex w-full justify-between gap-10 p-3 lg:p-8 text-body17 duration-500 cursor-pointer">
		<h3 class="!text-nov-red-300 text-md sm:h3 text-left font-normal transition-colors">
			<Formatted text={question} />
		</h3>
		<PlusMinusButton
			class="shrink-0"
			kind={open ? "minus" : "plus"}
			aria-label={open ? "Skrýt odpověď" : "Zobrazit odpověď"}
			onclick={(): void => {
				open = !open;
			}}
		/>
	</label>
	<div class={["grid overflow-clip transition-all duration-300", open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"]}>
		<div
			class={[
				"transition-all lg:pl-8 pr-20 lg:pr-27.5 min-h-0 w-full px-3 lg:px-6 font-normal text-body17 tracking-[0.005em]",
				open && "pb-8",
			]}
		>
			<div class="paragraph">
				{@render children()}
			</div>
		</div>
	</div>
</article>
